import { client } from './platform'

export function getIsMobile() {
	const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
	return client.is.mobile === true || width < 767
}

export function isInView(isMobile, el) {
	const rect = el.getBoundingClientRect()
	const totalHeight = window.innerHeight || document.documentElement.clientHeight
	const elementTop = Math.round(rect.top)
	const elementBottom = Math.round(rect.bottom)
	const scrolledTop = -1 * document.documentElement.scrollTop
	return (
		(elementTop >= 0 && elementTop <= totalHeight / 2) ||
		(isMobile && elementTop >= scrolledTop && elementTop <= scrolledTop + totalHeight / 2) ||
		(elementBottom <= totalHeight && elementBottom >= totalHeight / 2)
	)
}
